import { AbsenceOptions } from 'src/services/api/options/absenceOptions';

export const calendarKeys = {
  all: ['calendar'] as const,
  lists: () => [...calendarKeys.all, 'list'] as const,
  list: (options: AbsenceOptions) => [...calendarKeys.lists(), { ...options }],

  byId: (absenceId: string) => [...calendarKeys.all, absenceId] as const,
};
